const { FormControl, TextField } = require('@material-ui/core')
import { Autocomplete } from '@material-ui/lab'

const AutocompleteField = ({
   fieldName,
   formValue,
   handleChange,
   fieldLabel,
   fieldInvalid,
   errorMessage,
   required,
   ...otherProps
}) => {
   return (
      <FormControl fullWidth>
         <Autocomplete
            value={formValue}
            onChange={(event, value) => handleChange(value)}
            name={fieldName}
            error={fieldInvalid}
            renderInput={params => (
               <TextField
                  {...params}
                  label={`${fieldLabel}${required ? ' *' : ''}`}
                  variant="outlined"
                  size="small"
                  margin="normal"
                  error={Boolean(fieldInvalid)}
                  helperText={fieldInvalid && errorMessage}
               />
            )}
            {...otherProps}
         />
      </FormControl>
   )
}

export default AutocompleteField
